// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.barcode-list[data-v-740f23b2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.barcode-tag[data-v-740f23b2] {\n  margin: 0;\n}\n[data-v-740f23b2] .clickable-row {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
